// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import type { InternalContentProps } from './base';
import { DefaultProps, defaultConnect } from './base';
import ReportIAPPanel from '../ReportIAPPanel';
import { ContentType } from '../submit/SubmitIapVote';

/**
 * Panel for reporting a link.
 */
const ReportLinkPanel = (props: InternalContentProps) => (
  <ReportIAPPanel
    csrfToken={props.csrfToken}
    userId={props.userId}
    contentId={props.contentId}
    contentType={ContentType.LINK}
    onError={props.onError}
    onComplete={props.onComplete}
    repostInfo={props.repostInfo}
  >
    {panel => (
      <React.Fragment>
        {panel.createRadio('PROFANE_EXPLICIT_HATE_SPEECH')}
        {panel.createRadio('LINK_ILLEGAL_ACTIVITY')}
        {panel.createRadio('LINK_INCORRECT_OUTDATED_BROKEN')}
      </React.Fragment>
    )}
  </ReportIAPPanel>
);
ReportLinkPanel.defaultProps = DefaultProps;

// $FlowFixMe92
export default connect(state => defaultConnect(state))(ReportLinkPanel);
